import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["label", "labelHidden", "id", "feedbackClass", "groupClass", "labelClass", "groupAttrs"];
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AvGroup, AvFeedback } from 'availity-reactstrap-validation';
import classNames from 'classnames';
import { Label } from 'reactstrap';
import AvSelect from './AvSelect';
var AvSelectField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AvSelectField, _Component);
  function AvSelectField() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = AvSelectField.prototype;
  _proto.getChildContext = function getChildContext() {
    var _this = this;
    if (this.context.FormCtrl) {
      this.FormCtrl = _extends({}, this.context.FormCtrl);
      var registerValidator = this.FormCtrl.register;
      this.FormCtrl.register = function (input, updater) {
        if (updater === void 0) {
          updater = input && input.forceUpdate;
        }
        registerValidator(input, function () {
          _this.forceUpdate();
          if (updater) updater();
        });
      };
      return {
        FormCtrl: this.FormCtrl
      };
    }
    return {
      FormCtrl: this.context.FormCtrl
    };
  };
  _proto.render = function render() {
    var _this$props = this.props,
      label = _this$props.label,
      labelHidden = _this$props.labelHidden,
      _this$props$id = _this$props.id,
      id = _this$props$id === void 0 ? this.props.name : _this$props$id,
      feedbackClass = _this$props.feedbackClass,
      groupClass = _this$props.groupClass,
      labelClass = _this$props.labelClass,
      groupAttrs = _this$props.groupAttrs,
      attributes = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var validation = this.context.FormCtrl ? this.context.FormCtrl.getInputState(this.props.name) : {};
    var feedback = null;
    if (validation.errorMessage) {
      var feedbackClasses = classNames('d-block', feedbackClass);
      feedback = /*#__PURE__*/React.createElement(AvFeedback, {
        className: feedbackClasses
      }, validation.errorMessage);
    }
    var thisLabel = false;
    if (label) {
      var forLabel = id;
      if (attributes.inputId) {
        forLabel = attributes.inputId;
      } else {
        attributes.inputId = id;
      }
      thisLabel = /*#__PURE__*/React.createElement(Label, {
        for: forLabel,
        hidden: labelHidden,
        className: labelClass
      }, label);
    }
    return /*#__PURE__*/React.createElement(AvGroup, groupAttrs, thisLabel, /*#__PURE__*/React.createElement(AvSelect, attributes), feedback);
  };
  return AvSelectField;
}(Component);
AvSelectField.contextTypes = {
  FormCtrl: PropTypes.object
};
AvSelectField.childContextTypes = {
  FormCtrl: PropTypes.object
};
export default AvSelectField;